import { MessageConfig, MessageType, NotificationType } from '@routific/hive';
import { UNKNOWN_STOP } from './constants';

export const getAssigningStopMessageKey = (visitId: string): string => `assigning-stop-${visitId}`;

export const assigningStopMessage = (visitId: string, visitName?: string | null, targetName?: string | null): MessageConfig => ({
  key: getAssigningStopMessageKey(visitId),
  type: MessageType.LOADING,
  content: `Scheduling ${visitName || UNKNOWN_STOP} to ${targetName || 'Unknown'}`,
  dataCy: 'assigning-stop-message',
  duration: 0,
});

export const assignStopFailedNotification = (visitId: string, identifier?: string | null, targetName?: string | null) => ({
  id: `assign-stop-${visitId}-failure`,
  type: NotificationType.ERROR,
  message: `We couldn't schedule ${identifier || UNKNOWN_STOP} to ${targetName || 'Unknown'}.`,
  dataCy: 'assign-stop-message-failure',
});

export const bulkAssignStopFailedNotification = () => ({
  id: 'bulk-assign-stop-failure',
  type: NotificationType.ERROR,
  message: 'We couldn\'t schedule the selected orders.',
  dataCy: 'bulk-assign-stop-failure',
});

export const assignStopSuccessNotification = (visitId: string, visitName?: string | null, targetName?: string | null, onViewStop?: () => void) => ({
  id: `assign-stop-${visitId}-success`,
  type: NotificationType.SUCCESS,
  message: `Scheduled ${visitName || UNKNOWN_STOP} to ${targetName || 'Unknown'}.`,
  linkMessage: onViewStop ? 'View Stop' : undefined,
  linkOnClick: onViewStop,
  dataCy: 'assign-stop-message-success',
});
